import React from 'react';
import Popup from '../../components/ConformationPopup/Popup';
import { deleteRecruitmentMessageData, getRecruitmentMessageData } from '../../service/adminApi';
import { getTimestampToDate } from '../../utils/dateConvetor';

function RegistrationMessage({ updateData, editData, hideContainer }) {
    const [registrationMessageList, setRegistrationMessageList] = React.useState([]);
    const [flag, setFlag] = React.useState(false);
    const [deleteIndex, setDeleteIndex] = React.useState();

    React.useEffect(() => {
        getRegistrationMessage();
    }, []);

    React.useEffect(() => {

        if (updateData !== undefined) {
            updateRegistrationDetails(updateData);
        }
    }, [updateData]);

    const getRegistrationMessage = async () => {
        let data = {
            message_type: 'registration',
        };
        const response = await getRecruitmentMessageData(data);
        setRegistrationMessageList(response.data.data);
    };

    const updateRegistrationDetails = (data) => {
        switch (data) {
            case 'cancel':
                break;
            case 'update':
                getRegistrationMessage();
                break;
            default:
                break;
        }
    };

    const deleteRegistrationMessage = async () => {
        let data = {
            id: registrationMessageList[deleteIndex].id,
            is_active: false,
        };
        const response = await deleteRecruitmentMessageData(data);
        if (response.data.statusCode === 200) {
            let array = registrationMessageList;
            let arr = array.splice(deleteIndex, 1);
            let updatedData = array;
            setRegistrationMessageList(updatedData);
            setFlag(!flag);

        }
    };

    const renderRegistrationMessage = () => {
        if (registrationMessageList.length > 0) {
            return registrationMessageList.map((registrationMessage, index) => {
                let joinDate = getTimestampToDate(registrationMessage.modified_at, 3);
                return (
                    <div className="col-md-3 mt-4 mb-3">
                        <div className="card admin-card-styles border-0 ">
                            <div
                                className="admin-offboard-bg-holder admin-offboard-bg-card admin-offboard-bg-image"
                                style={{
                                    backgroundImage: 'url(/Images/card-bg.svg)',
                                }}
                            />
                            {/*/.bg-holder*/}
                            <div className="card-body position-relative mt-3">
                                <h6 className="bold-text font-12 mb-4">{registrationMessage.title}</h6>
                                <p className="regular-text font-12 mb-1 offboard-card-text-trunc">{registrationMessage.description}</p>
                                <p className="medium-text font-10 admin-offboard-dateupdate">Last Updated : {joinDate}</p>
                            </div>
                            <div class="card-kebab-position">
                                <img
                                    src="/Images/card_edit.svg"
                                    className="hive-table-sort"
                                    alt="Icon"
                                    class="m-1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                />
                                <ul className="dropdown-menu dropdown-menu-end offboarding-card-dropdown border-0 shadow-sm">
                                    <li>
                                        <a
                                            className="dropdown-item dditems border-bottom  semibold-text font-12 touchbase-kebabitems-color"
                                            type="button"
                                            // data-bs-toggle="offcanvas"
                                            // data-bs-target="#offcanvasRight"
                                            // aria-controls="offcanvasRight"
                                            onClick={() => {
                                                editData(registrationMessageList[index]);
                                            }}
                                        >
                                            Edit
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="dropdown-item dditems semibold-text font-12 touchbase-kebabitems-color"
                                            onClick={() => {
                                                setDeleteIndex(index);
                                            }}
                                            data-bs-toggle="modal"
                                            data-bs-target="#logout"
                                        >
                                            Delete
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <Popup
                            deleteData={() => {
                                deleteRegistrationMessage();
                            }}
                        />
                    </div>
                );
            });
        } else {
            return (
                <div className="row justify-content-center  w-100">
                    <img src="/Images/nodatafound.png" alt="no-records" style={{ width: 700, height: 500 }} />
                    <span className="row justify-content-center tt-bold font-16">No Registration Message</span>
                </div>
            );
        }
    };

    return (
        <div class="tab-pane fade show active mt-4" id="all_leave_request" role="tabpanel" aria-labelledby="all_leave_request_tab">
            <div className="row">{renderRegistrationMessage()}</div>
        </div>
    );
}

export default RegistrationMessage;
